import { render, staticRenderFns } from "./OneClickUpsell.vue?vue&type=template&id=64396684"
import script from "./OneClickUpsell.vue?vue&type=script&lang=js"
export * from "./OneClickUpsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports